import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';

@Directive({
  selector: 'p-table[appResponsiveTable], p-treeTable[appResponsiveTable]'
})
export class ResponsiveTableDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver | null = null;
  private applyTimeout: ReturnType<typeof setTimeout> | null = null;
  private applying = false;

  constructor(private el: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngAfterViewInit(): void {
    // Todo esto solo toca DOM plano (clases/spans), no bindings de Angular:
    // se corre fuera del zone para no disparar detección de cambios extra
    // en el componente host (eso llegó a interferir con datos cargados por HTTP).
    this.zone.runOutsideAngular(() => {
      this.scheduleApply();
      this.observer = new MutationObserver(() => {
        if (!this.applying) this.scheduleApply();
      });
      this.observer.observe(this.el.nativeElement, { childList: true, subtree: true, attributes: false });
    });
  }

  private scheduleApply(): void {
    if (this.applyTimeout) clearTimeout(this.applyTimeout);
    this.applyTimeout = setTimeout(() => this.applyLabels(), 150);
  }

  private applyLabels(): void {
    this.applying = true;
    this.observer?.disconnect();

    const host = this.el.nativeElement;
    const dataTable = host.querySelector('.p-datatable, .p-treetable') as HTMLElement | null;
    if (!dataTable) {
      this.reconnect();
      return;
    }

    dataTable.classList.add('osp-responsive-table');

    const headerRow = host.querySelector('thead tr:first-child');
    if (!headerRow) {
      this.reconnect();
      return;
    }

    const labels = Array.from(headerRow.querySelectorAll('th')).map(th =>
      this.extractText(th as HTMLElement)
    );

    host.querySelectorAll('tbody tr').forEach(row => {
      row.querySelectorAll('td').forEach((cell, i) => {
        const existing = cell.querySelector('.osp-label');
        if (existing) existing.remove();
        cell.classList.remove('osp-no-label');

        const label = labels[i] ?? '';
        if (label) {
          const span = document.createElement('span');
          span.className = 'osp-label';
          span.textContent = label;
          cell.insertBefore(span, cell.firstChild);
        } else {
          cell.classList.add('osp-no-label');
        }
      });
    });

    this.reconnect();
  }

  private reconnect(): void {
    this.applying = false;
    this.observer?.observe(this.el.nativeElement, { childList: true, subtree: true, attributes: false });
  }

  private extractText(th: HTMLElement): string {
    const clone = th.cloneNode(true) as HTMLElement;
    clone
      .querySelectorAll('p-sorticon, p-columnfilter, .p-sortable-column-icon, .p-column-filter')
      .forEach(el => el.remove());
    return clone.textContent?.trim() ?? '';
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    if (this.applyTimeout) clearTimeout(this.applyTimeout);
  }
}
